import './App.css';
import { getDatabase, ref, set, push, child, get, update, remove, onValue } from "firebase/database";
import { fbApp } from './firebase-config';

const fbDatabase = getDatabase(fbApp);


export const dbRef = ref(fbDatabase, '/');

export function addProspect(name, email, title, project, imgurl) {

  let uid = push(child(ref(fbDatabase), 'prospects')).key;
  if (isEmpty(name)) { name = "John Doe" };
  if (isEmpty(email)) { email = "no@mail.com" };
  if (isEmpty(title)) { title = "Unknown" };
  if (isEmpty(project)) { project = "All" };
  if (isEmpty(imgurl)) { imgurl = "https://firebasestorage.googleapis.com/v0/b/riotlabs-web.appspot.com/o/users%2Fincognito.jpeg?alt=media&token=5eeccf93-20ed-45a6-9e29-b00b982adb1a" };

  set(ref(fbDatabase, '/prospects/' + uid), {
    username: name,
    email: email,
    title: title,
    project: project,
    imgurl: imgurl
  });
}


export function registerInterest(email) {

  let timestamp = Date.now();

  let uid = push(child(ref(fbDatabase), "interest")).key;
  set(ref(fbDatabase, '/interest/' + uid), {
    email: email,
    timestamp: timestamp
  });
}

export function addUser(name, email, title, project, imgurl, business) {

  if (isEmpty(name)) { name = "John Doe" };
  if (isEmpty(email)) { email = "no@mail.com" };
  if (isEmpty(title)) { title = "Unknown" };
  if (isEmpty(project)) { project = "All" };
  if (isEmpty(imgurl)) { imgurl = "https://firebasestorage.googleapis.com/v0/b/riotlabs-web.appspot.com/o/users%2Fincognito.jpeg?alt=media&token=5eeccf93-20ed-45a6-9e29-b00b982adb1a" };

  let uid = push(child(ref(fbDatabase), 'users')).key;
  set(ref(fbDatabase, '/users/' + uid), {
    username: name,
    email: email,
    title: title,
    imgUrl: imgurl,
    level: /^[\w-]+(\.[\w-]+)*@(capgemini|sogeti)\.com$/.test(email) ? 100 : 0,
    business: business,
  });
}


export function addPitch(title, description, contact, imgurl, createdBy, level, uid) {
  return new Promise((resolve, reject) => {
    let uniqueId = uid;
    if (!uid) {
      uniqueId = push(child(ref(fbDatabase), 'pitches')).key;
    }

    const currentDate = new Date();
    const formattedDate = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${String(currentDate.getDate()).padStart(2, '0')}`;

    set(ref(fbDatabase, '/pitches/' + uniqueId), {
      title: title,
      description: description,
      contact: contact,
      imgUrl: imgurl,
      date: formattedDate,
      createdBy: createdBy,
      level: level
    })
      .then(() => {
        console.log('Pitch added successfully');
        resolve(); // Resolve the promise when the operation is successful
      })
      .catch((error) => {
        console.error('Error adding pitch: ', error);
        reject(error); // Reject the promise if there's an error
      });
  });
}

function isEmpty(_what) {
  if (typeof _what === 'undefined') {
    return true
  }

  if (_what === '') {
    return true
  }
  if (_what) {
    return false
  }
  return true // weird catchall
}

export async function updateLikes(pitchId, userId, like = true) {
  const pitchRef = ref(fbDatabase, `/pitches/${pitchId}`);

  // Fetch the existing likes array
  const snapshot = await get(pitchRef);
  if (!snapshot.exists()) {
    console.error(`Pitch with ID ${pitchId} does not exist.`);
    return;
  }

  const pitchData = snapshot.val();
  let likesArray = pitchData.likes || [];

  // Add or remove userId based on the 'like' argument
  if (like) {
    if (!likesArray.includes(userId)) {
      likesArray.push(userId);
    }
  } else {
    likesArray = likesArray.filter(id => id !== userId);
  }

  // Update the 'likes' attribute of the pitch
  return update(pitchRef, { likes: likesArray })
    .then(() => {
    })
    .catch((error) => {
      console.error("Error updating likes: ", error);
    });
}

export function removePitch(pitchId) {
  const pitchRef = ref(fbDatabase, `/pitches/${pitchId}`);

  return remove(pitchRef)
    .then(() => {
      console.log(`Pitch with ID ${pitchId} has been removed successfully.`);
    })
    .catch((error) => {
      console.error(`Error removing pitch with ID ${pitchId}: `, error);
    });
}

export async function getUserByUserId(userId) {
  try {
    // Create a reference to the 'users' node and fetch the user data
    const userRef = ref(fbDatabase, `/users/${userId}`);
    const snapshot = await get(userRef);

    if (snapshot.exists()) {
      // User data exists, return it
      return { ...snapshot.val(), uid: userId };
    } else {
      // User with the provided userId does not exist
      console.error(`User with userId ${userId} does not exist.`);
      return null;
    }
  } catch (error) {
    console.error("Error fetching user:", error);
    throw error; // You can handle the error as needed in your application
  }
}

export async function getUsersByLevel(targetLevel) {
  try {
    // Create a reference to the 'users' node
    const usersRef = ref(fbDatabase, '/users');

    // Fetch all users
    const snapshot = await get(usersRef);

    if (snapshot.exists()) {
      const allUsers = snapshot.val();

      // Filter users by the targetLevel
      const usersWithTargetLevel = Object.entries(allUsers)
        .filter(([userId, user]) => user.level === targetLevel)
        .map(([userId, user]) => ({ ...user, userId }));
      return usersWithTargetLevel;
    } else {
      // No users found in the database
      console.error("No users found in the database.");
      return [];
    }
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error; // You can handle the error as needed in your application
  }
}

export async function setUserLevel(userId, level) {
  try {
    const userRef = ref(fbDatabase, `/users/${userId}`);

    const snapshot = await get(userRef);

    if (snapshot.exists()) {
      const userData = snapshot.val();

      await update(userRef, { level: level });

      return { ...userData, level: level };
    } else {
      console.error(`User with userId ${userId} does not exist.`);
      return null;
    }
  } catch (error) {
    console.error("Error increasing user's level:", error);
  }
}

export async function getAllUsers() {
  try {
    const usersRef = ref(fbDatabase, '/users');
    const snapshot = await get(usersRef);
    if (snapshot.exists()) {
      const allUsers = snapshot.val();

      const usersWithUserId = Object.entries(allUsers)
        .map(([userId, user]) => ({ ...user, userId }));


      return usersWithUserId;
    } else {
      // No users found in the databases
      console.error("No users found in the database.");
      return [];
    }
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error; // You can handle the error as needed in your application
  }
}

export async function getUserByEmail(email) {
  try {
    // Create a reference to the 'users' node
    const usersRef = ref(fbDatabase, '/users');
    const snapshot = await get(usersRef);
    if (snapshot.exists()) {
      const allUsers = snapshot.val();
      const userWithEmail = Object.entries(allUsers).find(user => user[1].email === email);
      return { ...userWithEmail[1], userId: userWithEmail[0] };
    } else {
      // No users found in the database
      console.error("No users found in the database.");
      return [];
    }
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error; // You can handle the error as needed in your application
  }
}

export function addProject(title, description, contactName, contactUid, gitUrl, members, videoUrl, level, status, uid, imgUrl) {
  return new Promise((resolve, reject) => {
    let uniqueId = uid;
    if (!uid) {
      uniqueId = push(child(ref(fbDatabase), 'projects')).key;
    }

    const currentDate = new Date();
    const formattedDate = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${String(currentDate.getDate()).padStart(2, '0')}`;

    set(ref(fbDatabase, `/projects/${uniqueId}`), {
      title,
      description,
      contactName,
      contactUid,
      gitUrl,
      members,
      videoUrl,
      date: formattedDate,
      level,
      status,
      imgUrl
    })
      .then(() => {
        console.log('Project added successfully');
        resolve(); // Resolve the promise when the operation is successful
      })
      .catch((error) => {
        console.error('Error adding project: ', error);
        reject(error); // Reject the promise if there's an error
      });
  });
}

export async function getProjectsByLevelAndUser(targetLevel, userId, status) {
  try {
    const projectRef = ref(fbDatabase, '/projects');
    const snapshot = await get(projectRef);
    if (snapshot.exists()) {
      const allProjects = snapshot.val();

      // Modify each project object to include the projectId
      const filteredProjects = Object.entries(allProjects)
        .map(([projectId, project]) => ({ ...project, projectId }))
        .filter(
          (project) =>
            (project.level <= targetLevel || project.members.includes(userId)) &&
            (project.status === status)
        );

      return filteredProjects;
    } else {
      // No projects found in the database
      console.error("No projects found in the database.");
      return [];
    }
  } catch (error) {
    console.error("Error fetching projects:", error);
    throw error; // You can handle the error as needed in your application
  }
}

export async function getProjectByName(projectName) {
  try {
    const projectRef = ref(fbDatabase, '/projects');
    const snapshot = await get(projectRef);
    if (snapshot.exists()) {
      const allProjects = snapshot.val();

      // Search for the project with the specified name and retrieve its key
      const projectKey = Object.keys(allProjects).find(
        (key) => allProjects[key].title === projectName
      );

      if (projectKey) {
        // Found the project with the specified name
        const project = allProjects[projectKey];
        return { ...project, uid: projectKey };
      } else {
        // Project not found
        console.error(`Project with name '${projectName}' not found.`);
        return null;
      }
    } else {
      // No projects found in the database
      console.error("No projects found in the database.");
      return null;
    }
  } catch (error) {
    console.error("Error fetching projects:", error);
    throw error; // You can handle the error as needed in your application
  }
}

export function getPitches(level) {
  return new Promise(async (resolve, reject) => {
    try {
      const pitchesRef = ref(fbDatabase, '/pitches');
      const snapshot = await get(pitchesRef);

      if (snapshot.exists()) {
        const pitchesData = snapshot.val();

        if (pitchesData) {
          const pitchesArray = Object.entries(pitchesData).map(([uid, pitch]) => ({
            ...pitch,
            uid: uid // Add uid/key to each pitch item
          }));
          const filteredPitches = pitchesArray.filter((pitch) => pitch.level <= level);
          resolve(filteredPitches);
        } else {
          resolve([]);
        }
      } else {
        // No pitches found in the database
        console.error("No pitches found in the database.");
        resolve([]);
      }
    } catch (error) {
      console.error("Error fetching pitches:", error);
      reject(error); // Reject the promise if there's an error
    }
  });
}

export function getUsersByUserIds(userIds) {
  return new Promise(async (resolve, reject) => {
    try {
      const usersRef = ref(fbDatabase, '/users');
      const snapshot = await get(usersRef);

      if (snapshot.exists()) {
        const allUsers = snapshot.val();

        const usersArray = Object.entries(allUsers)
          .filter(([userId]) => userIds.includes(userId))
          .map(([userId, user]) => ({ ...user, userId }))
          .sort((a, b) => {
            if (a.username && b.username) {
              return a.username.localeCompare(b.username); // Sort by username
            }
            return 0; // If username is missing, maintain order
          });

        resolve(usersArray);
      } else {
        // No users found in the database
        console.error("No users found in the database.");
        resolve([]);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
      reject(error); // You can handle the error as needed in your application
    }
  });
}

export async function getProjectsByUserId(userId) {
  try {
    const projectRef = ref(fbDatabase, '/projects');
    const snapshot = await get(projectRef);

    if (snapshot.exists()) {
      const allProjects = snapshot.val();
      console.log(allProjects);
      // Filter projects where the user is a member
      const userProjects = Object.entries(allProjects)
        .filter(([projectId, project]) => project.members.includes(userId))
        .map(([projectId, project]) => ({ ...project, projectId }));

      return userProjects;
    } else {
      // No projects found in the database
      console.error("No projects found in the database.");
      return [];
    }
  } catch (error) {
    console.error("Error fetching user's projects:", error);
    throw error; // You can handle the error as needed in your application
  }
}